import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toDollars'
})
export class ToDollarsPipe implements PipeTransform {

  transform(value: string | number | undefined | null): string {
    if (!value) return '$ 0.00';
    let dollar
    if (typeof value === 'string') {
      dollar = parseInt(value) / 100
    }
    else if (typeof value === 'number') {
      dollar = value / 100
    }
    if (dollar < 0) {
      return '$ 0.' + dollar
    }
    else return '$ ' + dollar.toFixed(2)

  }
}

@Pipe({
  name: 'toAmount'
})
export class ToAmountPipe implements PipeTransform {

  transform(value: string | number | undefined | null , addSymbol : boolean = false): string {
    let result = '0.00'
    if (value) {
      const len = value.toString().length
      const amountString = value.toString()
      if (len > 2) {
        const firstPart = amountString.substring(0, len - 2)
        const secondPart = amountString.substring(len - 2, len)
        result = `${firstPart}.${secondPart}`
      }
      else if (len == 2) {
        result = `0.${amountString}`
      }
      else if (len == 1) {
        result = `0.0${amountString}`
      }
    }
    return (addSymbol ? `$${result}` : result )
    
  }
}


@Pipe({
  name: 'dollarsToCents'
})
export class DollarsToCents implements PipeTransform {
  transform(value: string | number | undefined | null, addSymbol: boolean = false): string {

    const val = value.toString()
    let amt = ''
    if (val.includes('.')) {
      // remove . and take only next 2 float even if it contains more than 2 float
      // if it contains one then add ono zero
      const [integer, float] = val.split('.')
      amt = `${integer}${float.length > 1 ? float.substring(0, 2) : float + '0'}`
    }
    else {
      amt = `${val}00`
    }
    return amt

  }
}
